import React from 'react';

const SvgDefs = () => (
  <svg width="0" height="0" style={{ position: 'absolute' }}>
    <defs>
      <linearGradient
        id="iconGradient"
        x1="0%"
        y1="0%"
        x2="100%"
        y2="0%"
        gradientTransform="rotate(0)"
      >
        <animateTransform
          attributeName="gradientTransform"
          type="rotate"
          from="0"
          to="360"
          dur="5s"
          repeatCount="indefinite"
        />
        <stop offset="0%" stopColor="rgba(0, 102, 219, 0.906)" />
        <stop offset="100%" stopColor="rgb(126, 0, 210)" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgDefs;
